<div class="reclass-conflicts">
    <div class="conflicts-header">
        <h3>{{ title }} ({{ cards.length }})</h3>
        <button class="btn-back" type="button" (click)="onBack()">‹ {{ backLabel }}</button>
    </div>
    <p class="conflicts-description">{{ description }}</p>

    <div class="conflict-card" *ngFor="let card of cards" [class.open]="card.expanded">
        <div class="conflict-card-header" (click)="toggleCard(card)">
            <span class="conflict-icon" aria-hidden="true">⚠</span>
            <span class="conflict-title"> {{ displayNumber(card.accountRef.accountNumber) }} {{ card.accountRef.name }} </span>
            <span class="conflict-counts">
                {{ card.transactions.length }} {{ transactionsCountLabel }}
                <span *ngIf="cyCount(card) > 0">· {{ cyLabel }}: {{ cyCount(card) }}</span>
                <span *ngIf="pyCount(card) > 0">· {{ pyLabel }}: {{ pyCount(card) }}</span>
            </span>
            <span class="chevron" [class.open]="card.expanded">▸</span>
        </div>

        <div class="conflict-card-body" *ngIf="card.expanded">
            <div class="total-row">
                <span>{{ totalLabel }}:</span>
                <strong>{{ card.totalAmount | number : '1.2-2' }}</strong>
            </div>

            <table class="conflict-tx-table">
                <thead>
                    <tr>
                        <th>{{ cyLabel }} / {{ pyLabel }}</th>
                        <th class="text-right">
                            {{ localizationKeys.aumico_grouping_masking_reclass_conflicts_table_amount | i18next }}
                        </th>
                        <th>{{ localizationKeys.aumico_grouping_masking_reclass_conflicts_table_source | i18next }}</th>
                        <th>{{ localizationKeys.aumico_grouping_masking_reclass_conflicts_table_target | i18next }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let t of card.transactions">
                        <td>{{ t.period === ReclassificationPeriod.CURRENT_YEAR ? cyLabel : pyLabel }}</td>
                        <td class="text-right">{{ t.amount | number : '1.2-2' }}</td>
                        <td>{{ displayNumber(t.source.accountNumber) }} {{ t.source.name }}</td>
                        <td>{{ displayNumber(t.target.accountNumber) }} {{ t.target.name }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="card-actions">
                <div class="reassign-block">
                    <select
                        class="select"
                        [value]="card.reassignTarget"
                        (change)="onReassignSelectChange(card, $any($event.target).value)"
                    >
                        <option value="">{{ reassignPlaceholder }}</option>
                        <option *ngFor="let a of targetsForCard(card)" [value]="optionKey(a)">
                            {{ displayNumber(a.accountNumber) }} {{ a.name }}
                        </option>
                    </select>
                    <button
                        class="btn btn-primary"
                        type="button"
                        [disabled]="!card.reassignTarget"
                        (click)="onReassignConfirm(card)"
                    >
                        {{ reassignLabel }}
                    </button>
                </div>
                <button class="btn btn-danger" type="button" (click)="onDelete(card)">
                    {{ deleteLabel }}
                </button>
            </div>
        </div>
    </div>
</div>
